export default __webpack_public_path__ + "static/performing-retail-back-9dcab12627e0df8499388e8d24f09757.webp";